import React, { useState, useEffect, memo, useContext } from 'react';
import Rating from 'react-rating';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import { rateMessageStar } from 'services/elvis';
import { ChatContext } from 'context/Context';

const MessageStars = ({ id, rating }) => {
    const { threads, threadsDispatch } = useContext(ChatContext);
    const [starRating, setStarRating] = useState(rating ?? 0);

    useEffect(() => setStarRating(rating), [id, rating]);

    return (
        <Rating
            initialRating={starRating}
            fullSymbol={<FontAwesomeIcon icon="star" className="text-primary me-1" />}
            emptySymbol={<FontAwesomeIcon icon="star" className="text-300 me-1" />}
            onChange={async (newRating) => {
                try {
                    await rateMessageStar(id, newRating);
                    setStarRating(newRating);
                    const updated = [...threads];
                    updated.flatMap(x => x.messages).find(x => x.id == id).rating = newRating;
                    threadsDispatch({ type: 'SET', payload: updated });
                    toast.success('Your rating has been saved. Thanks for taking care of business!');
                } catch (err) {
                    console.error(`Could not save rating for message ${id}`, err);
                    toast.error('Could not save your rating. Please try again later.');
                }
            }}
        />
    );
}

MessageStars.propTypes = {
    id: PropTypes.number,
    rating: PropTypes.number
};

export default memo(MessageStars);